import React from 'react';

interface ICheckSuccessProps {
	stroke?: string;
	size?: string;
	fill?: string;
	className?: string;
}

export const CheckSuccess = ({
	size = '24',
	className = '',
	fill = '#21A121',
	stroke = 'white',
}: ICheckSuccessProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		aria-labelledby="checkSuccess">
		<title id="checkSuccess">success checkmark</title>
		<path
			d="M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12Z"
			fill={fill}
		/>
		<path
			d="M16.1693 8.66699L11.2215 15.4696L7.83594 12.6867"
			stroke={stroke}
			strokeWidth="2"
			strokeLinejoin="round"
		/>
	</svg>
);
